import { type FC } from "react";
import { MiModal } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  TYPOGRAPHY_VARIANTS,
} from "@miplatform/constants";
import { mdiCancel } from "@mdi/js";
import { Typography, useTheme } from "@mui/material";

export type CancelAssignmentStagingModalProps = {
  open: boolean;
  stagedCount: number;
  onClose: () => void;
  onConfirmCancel: () => void;
  isLoading?: boolean;
};

export const CancelAssignmentStagingModal: FC<
  CancelAssignmentStagingModalProps
> = ({ open, stagedCount, onClose, onConfirmCancel, isLoading = false }) => {
  const theme = useTheme();

  return (
    <MiModal
      open={open}
      closeModal={onClose}
      width={330}
      titleIcon={mdiCancel}
      leftIconColor={theme.palette.red.main}
      title="Cancel assignments"
      loading={isLoading}
      actions={[
        {
          name: "Close",
          variant: BUTTON_VARIANTS.TEXT,
          color: BUTTON_COLORS.BLACK,
          onClick: onClose,
        },
        {
          name: "Cancel assignments",
          color: BUTTON_COLORS.RED,
          variant: BUTTON_VARIANTS.CONTAINED,
          disabled: isLoading || stagedCount < 1,
          onClick: onConfirmCancel,
        },
      ]}
    >
      <Typography
        variant={TYPOGRAPHY_VARIANTS.SUBTITLE2}
        color="grey"
        mb={2}
        px={2}
      >
        Are you sure you want to cancel your staged assignments?
      </Typography>
    </MiModal>
  );
};
